// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryCardInfoSwapTsx from "./CanaryCardInfoSwap.tsx";

let make = CanaryCardInfoSwapTsx.CanaryCardInfoSwap;

let make$1 = CanaryCardInfoSwapTsx.CanaryCardInfoSwapHeaderButton;

let HeaderButton = {
  make: make$1
};

export {
  make,
  HeaderButton,
}
/* make Not a pure module */
